module.exports = __webpack_public_path__ + "static/media/1.663124e5.jpg";